import Login from "@/views/Login";
import Library from "@/views/Library";
import Cards from "@/views/Cards";
import Card from "@/views/Card";
import Report from "@/views/Report";
import MassActions from "@/views/MassActions";
import Groups from "@/views/Groups";
import Matrix from "@/views/Matrix";
import Rbac from "@/views/settings/Rbac.vue";
import Chiefs from "@/views/settings/Chiefs.vue";
import Scales from "@/views/settings/Scales.vue";
import DynamicSettings from "@/views/settings/DynamicSettings.vue";
import Orgstruct from "@/views/Orgstruct.vue";
import LoginAdmin from "@/componentsCompany/tmk/views/LoginAdmin.vue";
import Deputies from "@/views/settings/Deputies.vue";
import HomeDashboard from "@/views/HomeDashboard.vue";


export default [
    {
        path: '/dashboards',
        name: 'Dashboards',
        component: HomeDashboard,
        meta: {title: 'Дашборды'}
    },
    {
        path: '/',
        name: 'Home',
        component: Cards,
        meta: {title: 'Карты'}
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {title: 'Логин', layout: 'empty-layout'}
    },
    {
        path: '/login-admin',
        name: 'LoginAdmin',
        component: LoginAdmin,
        meta: {title: 'Логин администратора', layout: 'empty-layout'}
    },
    {
        path: '/library/:type([\\w]+)',
        name: 'Library',
        component: Library,
        meta: {title: 'Библиотека'}
    },
    {
        path: '/cards',
        name: 'Cards',
        component: Cards,
        meta: {title: 'Карты'}
    },
    {
        path: '/card/:id(\\d+)',
        name: 'Card',
        component: Card,
        meta: {title: 'Карта'}
    },
    {
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {title: 'Конструктор отчетов'}
    },
    {
        path: '/matrix',
        name: 'Matrix',
        component: Matrix,
        meta: {title: 'Матрица КПЭ'}
    },
    {
        path: '/orgstruct',
        name: 'Orgstruct',
        component: Orgstruct,
        meta: {title: 'Оргструктура'}
    },


    {
        path: '/settings/dynamic',
        name: 'DynamicSettings',
        component: DynamicSettings,
        meta: {title: 'Настройки'}
    },
    {
        path: '/settings/chiefs',
        name: 'Chiefs',
        component: Chiefs,
        meta: {title: 'Настройка орг. структуры'}
    },
    {
        path: '/settings/rbac',
        name: 'Rbac',
        component: Rbac,
        meta: {title: 'Настройка ролей'}
    },
    {
        path: '/settings/scales',
        name: 'Scales',
        component: Scales,
        meta: {title: 'Настройка шкал'}
    },
    {
        path: '/settings/groups',
        name: 'Groups',
        component: Groups,
        meta: {title: 'Настройка групп'}
    },
    {
        path: '/settings/mass-actions',
        name: 'MassActions',
        component: MassActions,
        meta: {title: 'Массовые действия'}
    },
    {
        path: '/settings/deputies',
        name: 'Deputies',
        component: Deputies,
        meta: {title: 'Делегирование доступа'}
    },


]
